import { InjectionToken } from '@angular/core';
import { ConfigRepository } from './config.repository';

export const CONFIG_REPOSITORY = new InjectionToken<ConfigRepository>('ConfigRepository');
